export default Object.freeze([
	{ background: "#56626b", foreground: "#fff" },
	{ background: "#6c9380", foreground: "#fff" },
	{ background: "#c0ca55", foreground: "#fff" },
	{ background: "#3f628f", foreground: "#fff" },
	{ background: "#9ea49a", foreground: "#fff" },
	{ background: "#c19992", foreground: "#fff" },
	{ background: "#e1b5a5", foreground: "#fff" },
	{ background: "#b2bcbb", foreground: "#fff" },
	{ background: "#4c6b79", foreground: "#fff" },
	{ background: "#b1bec4", foreground: "#fff" },
	{ background: "#80959a", foreground: "#fff" },
	{ background: "#566b70", foreground: "#fff" },
	{ background: "#736477", foreground: "#fff" },
	{ background: "#eda7a7", foreground: "#fff" },
	{ background: "#8b91ab", foreground: "#fff" },
	{ background: "#787785", foreground: "#fff" },
	{ background: "#88b8cc", foreground: "#fff" },
	{ background: "#51688a", foreground: "#fff" },
	{ background: "#7f7269", foreground: "#fff" },
	{ background: "#bdb587", foreground: "#fff" },
	{ background: "#5e5953", foreground: "#fff" },
	{ background: "#b1ad9f", foreground: "#fff" },
	{ background: "#9ba7b1", foreground: "#fff" },
	{ background: "#778594", foreground: "#fff" },
	{ background: "#a28379", foreground: "#fff" },
	{ background: "#7e8999", foreground: "#fff" },
	{ background: "#a0a29f", foreground: "#fff" },
	{ background: "#83806f", foreground: "#fff" },
	{ background: "#86827d", foreground: "#fff" },
	{ background: "#ceb7aa", foreground: "#fff" },
	{ background: "#a9a198", foreground: "#fff" },
	{ background: "#a3978d", foreground: "#fff" },
	{ background: "#8e6a5f", foreground: "#fff" },
	{ background: "#9f8068", foreground: "#fff" },
	{ background: "#4c4543", foreground: "#fff" },
	{ background: "#a2a299", foreground: "#fff" },
	{ background: "#86837f", foreground: "#fff" },
	{ background: "#515f66", foreground: "#fff" },
	{ background: "#c3af98", foreground: "#fff" },
	{ background: "#758774", foreground: "#fff" },
	{ background: "#848f7c", foreground: "#fff" },
	{ background: "#5d564a", foreground: "#fff" },
	{ background: "#c9b8a2", foreground: "#fff" },
	{ background: "#988665", foreground: "#fff" },
	{ background: "#5b6262", foreground: "#fff" },
	{ background: "#747a80", foreground: "#fff" },
	{ background: "#4d5868", foreground: "#fff" },
	{ background: "#937f68", foreground: "#fff" },
	{ background: "#d4af87", foreground: "#fff" },
	{ background: "#94938f", foreground: "#fff" },
	{ background: "#b08d82", foreground: "#fff" },
	{ background: "#b6c4b1", foreground: "#fff" },
	{ background: "#98a48c", foreground: "#fff" },
	{ background: "#7c8a70", foreground: "#fff" },
	{ background: "#8e5a54", foreground: "#fff" },
	{ background: "#655250", foreground: "#fff" },
	{ background: "#9b827d", foreground: "#fff" },
	{ background: "#8898a5", foreground: "#fff" },
	{ background: "#9ea8b6", foreground: "#fff" },
	{ background: "#b5c4b1", foreground: "rgba(0, 0, 0, 0.6)" },
	{ background: "#c1cfd0", foreground: "rgba(0, 0, 0, 0.6)" },
	{ background: "#e8b6ab", foreground: "rgba(0, 0, 0, 0.6)" },
	{ background: "#deb8b8", foreground: "rgba(0, 0, 0, 0.6)" },
	{ background: "#d7c889", foreground: "rgba(0, 0, 0, 0.6)" },
	{ background: "#c8c1ae", foreground: "rgba(0, 0, 0, 0.6)" },
	{ background: "#c1bb96", foreground: "rgba(0, 0, 0, 0.6)" },
	{ background: "#d6c8af", foreground: "rgba(0, 0, 0, 0.6)" },
	{ background: "#cac095", foreground: "rgba(0, 0, 0, 0.6)" },
	{ background: "#e4dcd0", foreground: "rgba(0, 0, 0, 0.6)" },
	{ background: "#dfdee6", foreground: "rgba(0, 0, 0, 0.6)" },
	{ background: "#ddcdcd", foreground: "rgba(0, 0, 0, 0.6)" },
	{ background: "#b5c5c4", foreground: "rgba(0, 0, 0, 0.6)" },
	{ background: "#ebdac9", foreground: "rgba(0, 0, 0, 0.6)" },
	{ background: "#d9e1eb", foreground: "rgba(0, 0, 0, 0.6)" },
	{ background: "#f3d5d8", foreground: "rgba(0, 0, 0, 0.6)" },
	{ background: "#c9def1", foreground: "rgba(0, 0, 0, 0.6)" },
	{ background: "#dfe5de", foreground: "rgba(0, 0, 0, 0.6)" },
]);
